module.exports = __webpack_public_path__ + "static/media/ic_学生_pr.5740c94e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_学生_pr.svg
// module id = 194
// module chunks = 0